/* Ilustrovaná zeměkoule v hero sekci (sections/hero-two-beans.liquid).
   Kreslí do <canvas> ortografickou projekci: země, ze kterých je káva, rubínově,
   ostatní pevnina světle růžově. Koule se otáčí jako Země (západ → východ);
   nad prázdným Pacifikem zrychlí, aby v disku dlouho nezůstala jen voda.
   Závislosti: tb-globe-vendor.min.js (d3-geo + topojson-client jako window.tbGeo)
   a tb-world-110m.json (world-atlas countries-110m). */
(function () {
  'use strict';

  /* ISO 3166-1 numerické kódy, jak je nese world-atlas. Klíč = název tak,
     jak ho někdo napíše v theme editoru (bez ohledu na velikost písmen). */
  var COUNTRY_IDS = {
    'etiopie': '231', 'keňa': '404', 'kena': '404', 'uganda': '800', 'rwanda': '646',
    'burundi': '108', 'tanzanie': '834', 'jemen': '887', 'kolumbie': '170', 'peru': '604',
    'brazílie': '076', 'brazilie': '076', 'honduras': '340', 'papua-nová guinea': '598',
    'papua nová guinea': '598', 'papua': '598', 'guatemala': '320', 'salvador': '222',
    'el salvador': '222', 'nikaragua': '558', 'kostarika': '188', 'panama': '591',
    'mexiko': '484', 'ekvádor': '218', 'ekvador': '218', 'bolívie': '068', 'bolivie': '068',
    'indonésie': '360', 'indonesie': '360', 'indie': '356', 'vietnam': '704', 'čína': '156',
    'cina': '156', 'kongo': '180', 'malawi': '454', 'zambie': '894', 'kamerun': '120',
    'pobřeží slonoviny': '384', 'thajsko': '764', 'laos': '418', 'myanmar': '104',
    'filipíny': '608', 'východní timor': '626', 'dominikánská republika': '214',
    'haiti': '332', 'jamajka': '388', 'kuba': '192', 'venezuela': '862', 'usa': '840',
    'havaj': '840', 'austrálie': '036'
  };

  function parseList(text) {
    return (text || '').split(',').map(function (n) { return n.trim(); }).filter(Boolean);
  }

  /* Klíč pro porovnání jmen: malá písmena, bez diakritiky, spojovník = mezera.
     „Papua-Nová Guinea", „PAPUA NOVÁ GUINEA" i „papua nova guinea" dají totéž. */
  function fold(name) {
    return name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function titleCase(name) {
    return name.toLowerCase().replace(/(^|[\s-])\S/g, function (c) { return c.toUpperCase(); });
  }

  function countryId(name) {
    var id = COUNTRY_IDS[name.toLowerCase()];
    if (id) return id;
    var key = fold(name);
    for (var k in COUNTRY_IDS) if (fold(k) === key) return COUNTRY_IDS[k];
    return null;
  }

  function initGlobe(root) {
    var canvas = root.querySelector('canvas');
    var legend = root.querySelector('[data-globe-legend]');
    var dataUrl = root.getAttribute('data-globe-src');
    if (!canvas || !dataUrl || !window.tbGeo) return;
    var d3 = window.tbGeo;

    /* Úplný seznam zemí, ze kterých kávu vozíme nebo vozit můžeme. Na kouli
       jsou rubínové všechny – mapa ukazuje, kde se naše káva rodí, ne co je
       zrovna na skladě. */
    var allNames = parseList(root.getAttribute('data-globe-on'));
    var stockNames = parseList(root.getAttribute('data-globe-stock'));

    var ORIGINS = {};
    function register(names) {
      names.forEach(function (name) {
        var id = countryId(name);
        if (id && !ORIGINS[id]) ORIGINS[id] = { n: name, on: true };
      });
    }
    register(allNames);
    /* Země skladem, kterou do seznamu nikdo nedal, se na mapu přidá sama. */
    register(stockNames);

    /* Legenda naopak nese jen to, co je právě skladem – je to nabídka, ne mapa.
       Bez údaje o skladu vypíše celý seznam. */
    var legendNames = allNames;
    if (root.hasAttribute('data-globe-stock')) {
      var stockKeys = stockNames.map(fold);
      var allKeys = allNames.map(fold);
      legendNames = allNames.filter(function (n) { return stockKeys.indexOf(fold(n)) >= 0; });
      stockNames.forEach(function (n, i) {
        if (allKeys.indexOf(stockKeys[i]) < 0) legendNames.push(titleCase(n));
      });
    }

    /* Zvýrazněná země vede na vlastní kolekci té země. Když ji nemá, spadne
       to na výpis předfiltrovaný přes ?zeme= (čte ho tb-collection).
       Ztlumená země zůstává jen text. */
    var linkBase = root.getAttribute('data-globe-link') || '';
    var linkMap = {};
    try { linkMap = JSON.parse(root.getAttribute('data-globe-links') || '{}'); } catch (e) { linkMap = {}; }
    if (legend) {
      /* Země, kterou mapa nezná, na kouli nebude, ale v legendě zůstane. */
      var seen = {};
      legendNames.forEach(function (name) {
        var key = fold(name);
        if (seen[key]) return;
        seen[key] = true;
        var li = document.createElement('li');
        li.className = 'is-on';
        /* Klíč mapy je handle kolekce; fold() sjednotí diakritiku i pomlčky. */
        var href = linkMap[fold(name).replace(/\s+/g, '-')] || (linkBase ? linkBase + encodeURIComponent(name) : '');
        if (href) {
          var a = document.createElement('a');
          a.href = href;
          a.textContent = name;
          li.appendChild(a);
        } else {
          li.textContent = name;
        }
        legend.appendChild(li);
      });
    }

    /* Rychlost otáčení ve stupních za sekundu a násobek nad Pacifikem.
       Kávový pás končí u Papuy (~150° v. d.) a začíná u Mexika (~110° z. d.);
       mezi tím je jen voda, tak se přes ni přetočíme rychleji. */
    var SPEED = 24, PACIFIC_BOOST = 64 / 24;
    var PACIFIC_FROM = 170, PACIFIC_TO = 245, RAMP = 25; /* střed disku v ° v. d., 0–360 */
    var STILL_LAMBDA = -11;                              /* klid při reduced motion */

    var css = getComputedStyle(document.documentElement);
    function token(name, fallback) { return css.getPropertyValue(name).trim() || fallback; }
    var C_RUBY = token('--ruby', '#D8042A');
    var C_OAT = token('--oat-milk', '#FEEBDD');
    var C_MILK_LIGHT = token('--milkshake-light', '#EFC9D0');
    var C_INK = 'rgba(22,22,22,.62)';

    var ctx = canvas.getContext('2d');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    fetch(dataUrl).then(function (r) { return r.json(); }).then(function (topo) {
      var feats = d3.feature(topo, topo.objects.countries).features.filter(function (f) { return f.id !== '010'; });
      var onFeats = feats.filter(function (f) { return ORIGINS[f.id] && ORIGINS[f.id].on; });

      /* Ruční kresba: každý vrchol posuneme o stabilní pseudonáhodný kousek (stupně). */
      function hash(x, y) { var h = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453; return h - Math.floor(h); }
      function wobble(geo, amp) {
        function w(c) { return [c[0] + (hash(c[0], c[1]) - 0.5) * amp, c[1] + (hash(c[1], c[0]) - 0.5) * amp]; }
        function rings(polys) { return polys.map(function (r) { return r.map(w); }); }
        var g = geo.type === 'Feature' ? geo.geometry : geo;
        if (g.type === 'Polygon') return fixWinding({ type: 'Polygon', coordinates: rings(g.coordinates) });
        if (g.type === 'MultiPolygon') return fixWinding({ type: 'MultiPolygon', coordinates: g.coordinates.map(rings) });
        return g;
      }
      /* d3-geo chce vnější prstence po směru hodin; prstenec větší než polokoule je naruby. */
      function fixWinding(g) {
        var polys = g.type === 'Polygon' ? [g.coordinates] : g.coordinates;
        polys.forEach(function (poly) {
          poly.forEach(function (ring, i) {
            var a = d3.geoArea({ type: 'Polygon', coordinates: [ring] });
            if ((i === 0 && a > 2 * Math.PI) || (i > 0 && a < 2 * Math.PI)) ring.reverse();
          });
        });
        return g;
      }
      var landGeo = wobble(d3.merge(topo, topo.objects.countries.geometries.filter(function (g) { return g.id !== '010' && !ORIGINS[g.id]; })), 0.7);
      var onGeo = { type: 'GeometryCollection', geometries: onFeats.map(function (f) { return wobble(f, 0.5); }) };

      var proj = d3.geoOrthographic().clipAngle(90);
      var path = d3.geoPath(proj, ctx);
      var graticule = d3.geoGraticule().step([30, 30])();

      var size = 0;
      function resize() {
        var st = canvas.parentNode;
        var w = Math.floor(Math.min(st.clientWidth, st.clientHeight));
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        if (w === size || !w) return;
        size = w;
        canvas.width = canvas.height = Math.round(w * dpr);
      }
      window.addEventListener('resize', resize);

      var last = null, running = true;
      var lambda = STILL_LAMBDA; /* d3 λ; střed disku leží na zeměpisné délce −λ */

      /* 0 mimo Pacifik, 1 uprostřed, měkké nájezdy, aby zrychlení nebylo trhnutí. */
      function pacific(center) {
        var inRamp = function (edge, dir) { return Math.min(1, Math.max(0, dir * (center - edge) / RAMP)); };
        var a = inRamp(PACIFIC_FROM, 1), b = inRamp(PACIFIC_TO, -1);
        var u = Math.min(a, b);
        return u * u * (3 - 2 * u);
      }

      function frame(t) {
        if (running) requestAnimationFrame(frame);
        if (!reduce) {
          if (last === null) last = t;
          var dt = Math.min(t - last, 100) / 1000; /* po pauze karty neskočit */
          last = t;
          var center = ((-lambda % 360) + 360) % 360;
          lambda += dt * SPEED * (1 + (PACIFIC_BOOST - 1) * pacific(center));
          if (lambda > 360) lambda -= 360;
        }

        resize();
        var S = canvas.width, cx = S / 2, cy = S / 2, R = S * 0.47;
        if (!S) return;
        proj.rotate([lambda, 0]).translate([cx, cy]).scale(R);
        ctx.clearRect(0, 0, S, S);

        var lw = Math.max(1.2, S / 300); /* ~2px ruční linka při 560px */
        ctx.lineJoin = 'round'; ctx.lineCap = 'round';

        ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2);
        ctx.fillStyle = C_OAT; ctx.fill();

        /* poledníky a rovnoběžky: tenké tužkové linky */
        ctx.beginPath(); path(graticule);
        ctx.lineWidth = lw * 0.45; ctx.strokeStyle = 'rgba(22,22,22,.16)'; ctx.stroke();

        /* kontinenty: světlá růžová výplň, měkký inkoustový obrys */
        ctx.beginPath(); path(landGeo);
        ctx.fillStyle = C_MILK_LIGHT; ctx.fill();
        ctx.lineWidth = lw * 0.8; ctx.strokeStyle = C_INK; ctx.stroke();

        /* země původu: rubínová výplň – celý seznam, ne jen sklad */
        ctx.fillStyle = C_RUBY;
        ctx.beginPath(); path(onGeo); ctx.fill(); ctx.stroke();

        ctx.lineWidth = lw; ctx.strokeStyle = C_INK;
        ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.stroke();

        if (reduce) running = false;
      }
      requestAnimationFrame(frame);
      root.classList.add('is-ready');

      /* Mimo viewport nebo na skryté kartě nekreslíme. */
      if ('IntersectionObserver' in window && !reduce) {
        var resume = function () { if (!running) { running = true; last = null; requestAnimationFrame(frame); } };
        new IntersectionObserver(function (e) {
          if (e[0].isIntersecting && !document.hidden) resume(); else running = false;
        }, { threshold: 0.05 }).observe(canvas);
        document.addEventListener('visibilitychange', function () { if (document.hidden) running = false; else resume(); });
      }
    }).catch(function () { root.classList.add('is-failed'); });
  }

  function initAll() {
    document.querySelectorAll('[data-globe]:not([data-globe-init])').forEach(function (el) {
      el.setAttribute('data-globe-init', '');
      initGlobe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  /* Theme editor přerenderuje sekci bez reloadu stránky. */
  document.addEventListener('shopify:section:load', initAll);
})();
